import "core-js/modules/esnext.json.parse.js";
import Vue from "vue";
export function useCommon() {
  var _getCurrentInstance$p, _getCurrentInstance;
  const {
    $getI18nWord,
    $lang
  } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : Vue.prototype;
  function parseI18nJson(key) {
    const json = $getI18nWord(key);
    if (!json) return null;
    try {
      return JSON.parse(json);
    } catch (_unused) {
      return null;
    }
  }
  return {
    getI18nWord: $getI18nWord,
    lang: $lang,
    parseI18nJson
  };
}